import { Task } from '../../../lib/types';

export class SetTask {
  public static readonly type = '[Task] Set';
  constructor(public readonly task: Task) {}
}

export class ResetTask {
  public static readonly type = '[Task] Reset';
}
